function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M5,1.5 L5,2.5 L2,2.5 C1.48716416,2.5 1.06449284,2.88604019 1.00672773,3.38337887 L1,3.5 L1,8.5 C1,9.01283584 1.38604019,9.43550716 1.88337887,9.49327227 L2,9.5 L5,9.5 L5,10.5 L2,10.5 C0.8954305,10.5 0,9.6045695 0,8.5 L0,3.5 C0,2.3954305 0.8954305,1.5 2,1.5 L5,1.5 Z M8.45710678,2.5 L11.281,5.324 L11.2855339,5.32 L11.9926407,6.02710678 L11.988,6.031 L11.9926407,6.03553391 L11.2855339,6.74264069 L11.281,6.738 L8.45710678,9.56264069 L7.75,8.85553391 L10.105,6.499 L4,6.5 L4,5.5 L10.041,5.499 L7.75,3.20710678 L8.45710678,2.5 Z"
});

var SvgSignOut = function SvgSignOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-out.eb7aa4a2.svg";
export { ForwardRef as ReactComponent };